import { ReactNode, FC } from 'react'
import { Modal as AntModal } from 'antd'
import Icon from '@ant-design/icons'
import { ReactComponent as CloseIconSvg } from '../assets/icons/Close.svg'

export interface IModalProps {
  title?: string
  visible: boolean
  onOk?: (...args: any) => any
  onCancel: (...args: any) => any
  cancelText?: string
  okText?: string
  children?: ReactNode
  okIcon?: ReactNode
  cancelIcon?: ReactNode
  showOkButton?: boolean
  showCancelButton?: boolean
  loading?: boolean
}

export interface IFormModalProps extends IModalProps {
  form?: any
}

export const Modal: FC<IModalProps> = ({
  title,
  visible,
  onOk,
  onCancel,
  cancelText = 'CANCEL',
  okText = 'SUBMIT',
  children,
  okIcon,
  cancelIcon,
  showOkButton = true,
  showCancelButton = true,
  loading = false
}: IModalProps) => {
  return (
    <AntModal
        title={title}
        centered
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        cancelText={cancelText}
        okText={okText}
        cancelButtonProps={{
          shape: 'round',
          size: 'large',
          icon: cancelIcon,
          ...(!showCancelButton && { style: { display: 'none' } })
        }}
        okButtonProps={{
          icon: okIcon,
          shape: 'round',
          size: 'large',
          htmlType: 'submit',
          ...(!showOkButton && { style: { display: 'none' } })
        }}
        closeIcon={<Icon component={CloseIconSvg} style={{ color: '#fff', width: '24px', height: '24px' }} />}
        confirmLoading={loading}
    >
      {children}
    </AntModal>
  )
}
